import { GameStates } from './GameState'
import { GameAction, GameActions } from './GameStateAction'

import type { GameState } from './GameState.types'

type GameReducer = (action: GameAction, state: GameState) => GameState

const reducePregame = (action: GameAction, state: GameState) => {
  if (GameActions.isCreateGame(action)) {
    return GameStates.ReadyToPlay
  }
  if (GameActions.isEndGame(action)) {
    return GameStates.Finished
  }
  return state
}

const reduceReadyToPlay = (action: GameAction, state: GameState) => {
  if (GameActions.isStartPlay(action)) {
    return GameStates.Playing
  }
  if (GameActions.isPausePlay(action)) {
    return GameStates.Paused
  }
  if (GameActions.isEndGame(action)) {
    return GameStates.Finished
  }

  return state
}

const reducePlaying = (action: GameAction, state: GameState) => {
  if (GameActions.isPausePlay(action)) {
    return GameStates.Paused
  }
  if (GameActions.isResetPlay(action)) {
    return GameStates.Reset
  }
  if (GameActions.isEndGame(action)) {
    return GameStates.Finished
  }
  if (GameActions.isSleepPlay(action)) {
    return GameStates.Sleep
  }

  return state
}

const reduceSleeping = (action: GameAction, state: GameState) => {
  if (GameActions.isStartPlay(action)) {
    return GameStates.Playing
  }
  return state
}

const reduceReset = (action: GameAction, state: GameState) => {
  if (GameActions.isStartPlay(action)) {
    return GameStates.Playing
  }
  if (GameActions.isEndGame(action)) {
    return GameStates.Finished
  }

  if (GameActions.isPausePlay(action)) {
    return GameStates.Paused
  }

  return state
}

const reducePaused = (action: GameAction, state: GameState) => {
  if (GameActions.isStartPlay(action)) {
    return GameStates.Playing
  }
  if (GameActions.isEndGame(action)) {
    return GameStates.Finished
  }

  if (GameActions.isResetPlay(action)) {
    return GameStates.Reset
  }

  return state
}

const reduceFinished = (action: GameAction, state: GameState) => {
  if (action && state) {
    return GameStates.Finished
  }
  return GameStates.Finished
}

export const GameReducer: GameReducer = (action, state) => {
  if (GameStates.isPreGame(state)) {
    return reducePregame(action, state)
  }
  if (GameStates.isReadyToPlay(state)) {
    return reduceReadyToPlay(action, state)
  }
  if (GameStates.isPlaying(state)) {
    return reducePlaying(action, state)
  }
  if (GameStates.isSleep(state)) {
    return reduceSleeping(action, state)
  }
  if (GameStates.isReset(state)) {
    return reduceReset(action, state)
  }
  if (GameStates.isPaused(state)) {
    return reducePaused(action, state)
  }
  if (GameStates.isFinished(state)) {
    return reduceFinished(action, state)
  }

  return state
}
